/**
 * URL scrubber for telemetry / breadcrumb surfaces.
 *
 * Strips query string and fragment from a URL before it leaves the SPA via
 * Application Insights envelopes, breadcrumb buffers, or error boundaries.
 * Query parameters routinely carry PII or secrets (`?token=...`,
 * `?email=...`, signed-URL signatures, OAuth fragments) and must never land
 * in centralised observability storage.
 *
 * Intentionally a standalone, dependency-free module so any layer
 * (auth-token, mutator, app-insights initializers, ErrorBoundary) can import
 * it without pulling the AI SDK transitively.
 *
 * Accepts either a `URL` instance or a string; relative strings are resolved
 * against `window.location.origin` (the only callers that pass strings live
 * in the SPA, where a DOM `window` is always available).
 */
export function scrubUrl(input: URL | string): string {
  const u = input instanceof URL ? input : new URL(input, window.location.origin);
  return `${u.origin}${u.pathname}`;
}
